// extracted by mini-css-extract-plugin
export var card = "styles-module--card--6a9c9";
export var contactButton = "styles-module--contactButton--0e0c0";
export var container = "styles-module--container--a1b7f";
export var socialLink = "styles-module--socialLink--dfa9b";
export var socials = "styles-module--socials--7034c";
export var wordmark = "styles-module--wordmark--1f633";